

var Top = {
  shoptetUpload: "/user/documents/upload/larecomp",
  httpShoptetUpload: "https://www.recomp.cz/user/documents/upload/larecomp",
  neco: "text1",
  jeIframe: false,
  idStrany: false,
  zobrazWidget: false,
  zobrazNoveParametry: false,
  currencyInfo:false,
  mena:'CZK',

  Uzivatel: {
    prihlasen: null,
    Customer: false, //dataLayer shotetu
    overeniPrihlaseni: function() {
      var $a = $('a[href="/klient/"]');
      if ($a.length) return true;

      return false;
    },

    jePrihlasen: function() {
      return Top.Uzivatel.prihlasen;
    }
  },
  _vratUzivatele: function() {
    let a = window.dataLayer || false;
    if (!a) return false;
    return fce.get(window.dataLayer[0], "shoptet.customer") || false;
  },
  prevedNaEura:function(suma){
   
    if(Top.mena=='CZK'){
      return suma;
    }else{
      return Math.round(suma * Top.currencyInfo.exchangeRate * 100) / 100;
    }
  },

  formatujMenu:function(suma){
    if(Top.mena =='EUR'){
      return '€'+Number(suma).formatCisla();
    }else {
      return  Number(suma).formatCisla() + " Kč";
    }

  },
  _init: function() {
    Top.Uzivatel.Customer = Top._vratUzivatele();
    let $stav = Top.Uzivatel.overeniPrihlaseni();
    Top.Uzivatel.prihlasen = $stav;
    
    Top.mena = window.getShoptetDataLayer('currency') || 'CZK';
    Top.currencyInfo = window.getShoptetDataLayer('currencyInfo') || false;
  }
};

Top._init();

export { Top };
